import { useFilterVisibleDispatch } from './lib';

const OpenFilter = ({ render, ...props }) => {
  const openFilter = useFilterVisibleDispatch();
  return render({ openFilter, ...props });
};

export default OpenFilter;
